const $ = jQuery.noConflict();
import 'slick-carousel';

import lottieWeb from 'lottie-web';

'use strict';

const Animations = {
	init: function() {
		this.animationSetup();
	},

	animationSetup: function() {
		const animContainer = document.getElementById('animation');
		let animation;

		if (animContainer) {
			animation = lottieWeb.loadAnimation({
				container: animContainer,
				renderer: 'svg',
				path: '../wp-content/themes/fws-ahivim/src/assets/animations/LogoAnimationAhivimNew2.json',
				loop: false,
				autoplay: false,
				rendererSettings: {
					progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
				},
			});
            animation.play();
		}

        if(animContainer && $('body').hasClass('homepage')) {
			setTimeout(() => {
                $('body').addClass('scene-one');
            }, 2000);
            setTimeout(() => {
                $('body').addClass('scene-two');
            }, 4500);
        }
    }
};

export default Animations;

